export default "__VITE_ASSET__DOoIBbQN__"